export const nameRegex = /^[a-zA-Z ]+$/;
export const numberRegex = /^(?=.*[0-9])/;
export const numbersOnlyRegex = /^[0-9]+$/;
export const uppercaseRegex = /^(?=.*[A-Z])/;
export const lowercaseRegex = /^(?=.*[a-z])/;
export const specialCharRegex = /^(?=.*[!@#$%^&*])/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
